import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeTag',
  standalone: true,
})
export class RemoveTag implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
   
    return value.replace(/<\/?[^>]+(>|$)+/g, "");
  }
}
